import r from "./index.es267.js";
const n = r.hasStandardBrowserEnv ? /* @__PURE__ */ ((o, e) => (t) => (t = new URL(t, r.origin), o.protocol === t.protocol && o.host === t.host && (e || o.port === t.port)))(
  new URL(r.origin),
  r.navigator && /(msie|trident)/i.test(r.navigator.userAgent)
) : () => !0;
export {
  n as default
};
//# sourceMappingURL=index.es419.js.map
